import ContactFormSubject from "../models/ContactFormSubject";

export default class ContactFormSubjectMapper {
    public map(data : any) : ContactFormSubject {
        const subject = new ContactFormSubject();
        subject.id = data.ID;
        subject.text = data.Text;
        subject.showClientInfo = data.ShowClientInfo;
        return subject;
    }
}